import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {from, of, ReplaySubject} from "rxjs";
import {delay, filter, first, last, takeUntil, tap} from "rxjs/operators";
import {Uuid} from "../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";
import {RegistrationIdInlineForm} from "../registration-details-form/registration-details-form.component";
import {Registration} from "../../../shared/interface/registration";
import {IdentifierService} from "../../../shared/services/identifier.service";
import {RegistrationService} from "../../../shared/services/registration.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {
  DICT_TYPE_REGISTRATION_ID_TYPE,
  DictService, FILE_TYPE_ANOTHER_MULTI, REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION,
  REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT, REGISTRATION_ID_TYPE_SENT, SALES_COMPENSA, SALES_COMPENSA_WIENER
} from "../../../shared/services/dict.service";
import {ContractService} from "../../../shared/services/contract.service";
import {OfwcaService} from "../../../shared/services/ofwca.service";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {AuthService} from "../../../shared/services/auth.service";
import {Dictionary} from "../../../shared/interface/dictionary";
import {ListResponse} from "../../../shared/interface/response/list-response";
import {RegistrationIdentifier} from "../../../shared/interface/registration-identifier";
import moment from "moment/moment";
import {Ofwca} from "../../../shared/interface/ofwca";
import {Contract} from "../../../shared/interface/contract";
import {InsuranceCompany} from "../../../shared/interface/insurance-company";
import {OfwcaRegistrationInfo} from "../../../shared/interface/ofwca-registration-info";
import {validNip} from "../../../shared/validator/nip-validator";
import {validPhoneNumber} from "../../../shared/validator/phone-validator";

@Component({
  selector: 'app-registration-identifiers-form',
  templateUrl: './registration-identifiers-form.component.html',
  styleUrls: ['./registration-identifiers-form.component.scss']
})
export class RegistrationIdentifiersFormComponent implements OnInit {
  @Input() registrationObject?: Registration;
  @Input() identifierObject?: any;

  @Output() closeModificationIdentifier = new EventEmitter<any>();


  processingRequest = false;
  disable = false;
  registrationIdForms: { [key: string]: RegistrationIdInlineForm } = {};
  errors: any = {};
  userPermissionss: ReplaySubject<UserPermissions>;
  userPermissions: UserPermissions;


  selectedContract?: Contract;
  selectedOfwca?: Ofwca;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private registrationService: RegistrationService,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private dictService: DictService,
    private ofwcaService: OfwcaService,
    private identifierService: IdentifierService,
    private auth: AuthService,

  ) {
    this.userPermissionss = auth.getUserPermissions();

    this.auth.getUserPermissions()
      .subscribe((userPermissions: UserPermissions) => {
        this.userPermissions = userPermissions;
      });
  }

  ngOnInit(): void {
    this.initialize(this.registrationObject);

  }

  save(): void {
    this.processingRequest = true;
    const forms = [];
    let filterforms = [];
    for (const [key, value] of Object.entries(this.registrationIdForms)) {
        forms.push(value);
    }

    if (forms.length === 0) {
      forms.push(null);
    }
    filterforms = forms.filter(item => item.currentIdentifierId === this.identifierObject.uuid);

    from(filterforms)
      .pipe(
        tap((inlineForm: RegistrationIdInlineForm) => {
          if (!inlineForm) {
            return;
          }

          const idValue = inlineForm.formGroup.get('value').value;
          this.identifierService.sendForm({
            registration: inlineForm.formGroup.get('registration').value,
            type: inlineForm.formGroup.get('type').value,
            value: Array.isArray(idValue) ? idValue : [idValue],
          }, inlineForm.currentIdentifierId)
            .subscribe((response: Uuid) => {
              this.snackBar.open('Pomyślnie zaktualizowano identyfikator', '', {
                duration: 2000,
              });
              this.processingRequest = false;

              this.closeModificationIdentifier.emit();
            }, (error: HttpErrorResponse) => {
              this.processingRequest = false;

              this.snackBar.open('Podczas aktualizacji identyfikatorów wystąpił błąd', error.status.toString(), {
                duration: 2000,
              });

              if (error.status === 400) {
                this.errors = error.error.error.list;
              }
            });
        })
      ).subscribe();
  }
  cancel(): void {
    this.closeModificationIdentifier.emit();
  }
  parseValue(value: string, type: Dictionary): string|string[] {
    if (!value) {
      return '';
    }

    if (type.valueType === 'bool') {
      if (value.toLowerCase() === 'tak') {
        return 'Tak';
      } else {
        return 'Nie';
      }
    } else {
      return value.split(',');
    }
  }
  initialize(registration: Registration): void {
    of(registration)
      .pipe(
        delay(0),
        tap(() => {
          this.ofwcaService.get(registration.ofwca.uuid)
            .subscribe((ofwca: Ofwca) => {
              this.selectedOfwca = ofwca;
            });
          this.buildIdentifierForms();
        }),
        delay(0),
        tap(() => {
          this.initialized.next(true);
        })
      ).subscribe();
  }


  buildIdentifierForms(): void {
    this.dictService.getDictSubject()
      .pipe(
        first()
      )
      .subscribe((items: Dictionary[]) => {

        this.registrationService.getRegistrationIds(this.registrationObject.uuid)
          .pipe(first())
          .subscribe((response: ListResponse<RegistrationIdentifier>) => {

            items.forEach((dict: Dictionary) => {
              if (
                dict.type === DICT_TYPE_REGISTRATION_ID_TYPE && this.registrationObject
                && this.registrationObject.insuranceCompany.registrationIdTypes.includes(dict.key)
                && (!dict.secured || (dict.secured && this.userPermissions.registration.id_import))
              ) {

                let exists = false;
                response.items.forEach((identifier: RegistrationIdentifier) => {
                  if (dict.key === identifier.type.key) {
                    this.registrationIdForms[dict.key] = {
                      identifierName: dict.name,
                      currentIdentifierId: identifier.uuid,
                      typeDict: dict,
                      formGroup: this.fb.group({
                        registration: this.fb.control(this.registrationObject.uuid),
                        type: this.fb.control(dict.id),
                        value: this.fb.control(this.parseValue(identifier.value, dict)),
                      })
                    };
                    exists = true;
                  }
                });

                if (!exists) {
                  this.registrationIdForms[dict.key] = {
                    identifierName: dict.name,
                    currentIdentifierId: null,
                    typeDict: dict,
                    formGroup: this.fb.group({
                      registration: this.fb.control(this.registrationObject.uuid),
                      type: this.fb.control(dict.id),
                      value: this.fb.control(''),
                    })
                  };
                }
              }
            });
          });
      });
  }
  getControl(group: FormGroup, name: string): FormControl {
    return group.get(name) as FormControl;
  }

   readonly REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT = REGISTRATION_ID_TYPE_REQUEST_FOR_DELETION_SENT;
   readonly REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION = REGISTRATION_ID_TYPE_CONSENT_TO_DUAL_REGISTRATION;
   readonly REGISTRATION_ID_TYPE_SENT = REGISTRATION_ID_TYPE_SENT;
   readonly FILE_TYPE_ANOTHER_MULTI = FILE_TYPE_ANOTHER_MULTI;
}
